import { render } from "./LicenseDMain.vue?vue&type=template&id=5a05c238&scoped=true"
import script from "./LicenseDMain.vue?vue&type=script&lang=js"
export * from "./LicenseDMain.vue?vue&type=script&lang=js"

import "./LicenseDMain.vue?vue&type=style&index=0&id=5a05c238&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a05c238"]])

export default __exports__